import React, { Component } from "react";
import { Link } from "react-router-dom";
import Spinner from "../Spinner/Spinner";

class PaymentFailed extends Component {
  state = {
    pageSpinner: true,
  };

  componentDidMount() {
    this.setState({ pageSpinner: false });
  }

  render() {
    return (
      <>
        {this.state.pageSpinner ? (
          <Spinner />
        ) : (
          <>
            <div className='HeadPay'>
              <span>پرداخت</span>
              <a
                href='/shoppingCart/Payment'
                onclick='close_window();return false;'>
                &#10005;
              </a>
            </div>
            <div className='paymentDiv'>
              <div className='paymentDivBody'>
                <div className='Img'>
                  <img src='/public/assets/icons/warning1.svg' alt='warning' />
                </div>
                <span className='TextWarninig'>
                  متاسفانه پرداخت شما انجام نگرفت
                </span>

                <div className='Content'>
                  <div className='Bottom'>
                    <span className='TrackingCode'>هزینه پرداخت شده:</span>
                    <span className='Numbers'>
                      {this.props?.price?.toLocaleString()} تومان
                    </span>
                  </div>
                </div>
              </div>
              <div className='paymentFooter'>
                <button className='Support'>تماس با پشتیبانی</button>
                <div className='paymentFooter'>
                  <Link to={"/profile/myOrders"}>
                    <button className='OrderFactor'>مشاهده سفارش</button>
                  </Link>
                </div>
              </div>
            </div>
          </>
        )}
      </>
    );
  }
}

export default PaymentFailed;
